import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, InputAdornment, TextField, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PaxInputProps {
  label: string;
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

const PaxInput: React.FC<PaxInputProps> = ({ label, value, onIncrement, onDecrement, ...props }) => (
  <TextField
    variant="outlined"
    size="medium"
    style={{ marginBottom: '1rem' }}
    label={label}
    value={value}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <IconButton onClick={onDecrement} edge="start" size="small">
              <RemoveIcon />
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={onIncrement} size="small">
              <AddIcon />
            </IconButton>
          </InputAdornment>
        ),
        inputProps: {
          min: 1,
          size: 20,
          type: 'text',
        },
      },
    }}
    onWheel={(e) => (e.target as HTMLInputElement).blur()}
    onChange={(_e) => {}}
    {...props}
  />
);

export interface PaxComponentProps {
  adults: number;
  setAdults: React.Dispatch<React.SetStateAction<number>>;
}

const PaxComponent: React.FC<PaxComponentProps> = ({ adults, setAdults }) => {
  const incrementCount = (setter: React.Dispatch<React.SetStateAction<number>>) => () => {
    setter((prevCount) => {
      const newCount = prevCount + 1;
      return newCount;
    });
  };

  const { t: translate } = useTranslation();

  const decrementCount = (setter: React.Dispatch<React.SetStateAction<number>>) => () => {
    setter((prevCount) => {
      const newCount = prevCount > 1 ? prevCount - 1 : 1;
      return newCount;
    });
  };

  return (
    <Box>
      <PaxInput label={translate('coreUi.data_grid.adults')} value={adults} onIncrement={incrementCount(setAdults)} onDecrement={decrementCount(setAdults)} />
    </Box>
  );
};

export default PaxComponent;
